import React, { useState } from 'react';
import {
    AlertError
} from '../../utils/componentes-utiles/AlertError';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Grid,
    Typography,
    Button,
    CircularProgress,
    useMediaQuery
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BarrasHorasInvertidasHorizontalesDia } from '../../utils/componentes-utiles/graficas/BarrasHorasInvertidasHorizontalesDia';
import { useTheme } from '@mui/material/styles';

export const DialogHorasInvertidas = ({ open, setOpen, data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [loaded, setLoaded] = useState(true);
    const [showError, setShowError] = useState(false);

    const handleClose = () => setOpen(false);

    const convertirHoras = (horas) => {
        const h = Math.floor(horas);
        const m = Math.round((horas - h) * 60);
        return `${h}h${m > 0 ? ` ${m}min` : ''}`;
    };

    const obtenerFechaCompleta = (diaTexto) => {
        const match = diaTexto.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
        if (!match) return diaTexto;
        const dia = parseInt(match[1], 10);
        const mes = parseInt(match[2], 10) - 1;
        const hoy = new Date();
        const fecha = new Date(hoy.getFullYear(), mes, dia);

        const diasLargos = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const mesesLargos = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        return `${diasLargos[fecha.getDay()]} ${fecha.getDate()} de ${mesesLargos[fecha.getMonth()]}`;
    };

    // 🧮 Total general
    const totalHoras = data?.horasSemana?.reduce((total, dia) => {
        return total + dia.tareas.reduce((suma, tarea) => suma + tarea.horas, 0);
    }, 0) || 0;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md"
            PaperProps={{
                style: {
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '800px',
                    margin: isMobile ? 20 : undefined,
                    borderRadius: isMobile ? 0 : 12
                }
            }}
        >
            <DialogTitle>
                Registro de horas invertidas en tareas
                {totalHoras > 0 && (
                    <Typography variant="subtitle2" color="textSecondary">
                        Total: {convertirHoras(totalHoras)}
                    </Typography>
                )}
            </DialogTitle>

            <DialogContent dividers style={{ padding: isMobile ? '8px' : '24px' }}>
                {!loaded ? (
                    <Box display="flex" justifyContent="center" py={3}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        {data?.horasSemana?.length > 0 ? (
                            data.horasSemana.map((dia, index) => {
                                const totalDia = dia.tareas.reduce((suma, tarea) => suma + tarea.horas, 0);
                                return dia.tareas.length > 0 && (
                                    <Accordion key={index} style={{ marginBottom: '12px' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${index}-content`}
                                            id={`panel${index}-header`}
                                        >
                                            <Box>
                                                <Typography variant="subtitle1">
                                                    {obtenerFechaCompleta(dia.dia)}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    Total: {convertirHoras(totalDia)}
                                                </Typography>
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box sx={{ overflowX: 'auto' }}>
                                                <BarrasHorasInvertidasHorizontalesDia data={dia.tareas} />
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                No hay tareas registradas esta semana.
                            </Typography>
                        )}
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cerrar</Button>
            </DialogActions>

            <AlertError
                open={showError}
                setOpen={setShowError}
                titulo="Error"
                mensaje="No se ha podido exportar los fichajes"
            />
        </Dialog>
    );
};
